import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { LegacyColorMap } from '../../../theme/LegacyColorMap.es.js';
import { debounce } from '../../../utils/debounce.es.js';
import { Avatar } from '../../display/Avatar/Avatar.es.js';
import 'clsx';
import '../../display/Icon/Icon.es.js';
import '../../navigation/Link/Link.es.js';
import '../../navigation/Indicator/Indicator.es.js';
import { Paginator } from '../../navigation/Paginator/Paginator.es.js';
import { ScrollSnap } from '../../display/Carousel/ScrollSnap/ScrollSnap.es.js';
import { remapDeprecatedColors } from '../TestimonialSolo/TestimonialMapping.es.js';

const testimonialCarouselContainer = "_testimonial-carousel-container_ay07t_1";
const testimonialContainerWrapper = "_testimonial-container-wrapper_ay07t_15";
const testimonialContainer = "_testimonial-container_ay07t_15";
const testimonial = "_testimonial_ay07t_1";
const avatarContainer = "_avatar-container_ay07t_72";
const quote = "_quote_ay07t_77";
const author = "_author_ay07t_95";
const styles = {
	testimonialCarouselContainer: testimonialCarouselContainer,
	testimonialContainerWrapper: testimonialContainerWrapper,
	testimonialContainer: testimonialContainer,
	testimonial: testimonial,
	avatarContainer: avatarContainer,
	quote: quote,
	author: author
};

const TestimonialCarousel = (props) => {
  const [activeTestimonialIndex, setActiveTestimonialIndex] = useState(0);
  const testimonialContainerRef = useRef(null);
  const [testimonialContainerWidth, setTestimonialContainerWidth] = useState(0);
  useEffect(() => {
    var _a;
    setTestimonialContainerWidth(((_a = testimonialContainerRef === null || testimonialContainerRef === void 0 ? void 0 : testimonialContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0);
  }, []);
  useLayoutEffect(() => {
    const onResize = debounce(() => {
      var _a;
      setTestimonialContainerWidth(((_a = testimonialContainerRef === null || testimonialContainerRef === void 0 ? void 0 : testimonialContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0);
    }, 100);
    window.addEventListener("resize", onResize, { capture: true });
    return () => {
      window.removeEventListener("resize", onResize, { capture: true });
    };
  });
  const paginator = jsx(Paginator, { currentPageIndex: activeTestimonialIndex, onPaginate: ({ pageIndex: index }) => setActiveTestimonialIndex(index), pageUrls: Array.from({ length: props.testimonials.length }) });
  return jsxs("div", { className: styles.testimonialCarouselContainer, style: {
    "--_zds-testimonialcarousel-background-color": Colors[LegacyColorMap[remapDeprecatedColors(props.backgroundColor || "neutral100")]]
  }, "data-zds": true, children: [jsx("div", { className: styles.testimonialContainerWrapper, ref: testimonialContainerRef, "data-zds": true, children: testimonialContainerWidth && jsx(ScrollSnap, { gap: 60, itemWidth: testimonialContainerWidth, onScroll: (index) => {
    setActiveTestimonialIndex(index);
  }, pageIndex: activeTestimonialIndex, scrollSnapAlign: "center", children: props.testimonials.map((testimonial, i) => jsxs("div", { className: styles.testimonialContainer, "data-zds": true, children: [jsx("div", { "data-zds": true, children: testimonial.mediaElement }), jsxs("div", { className: styles.testimonial, "data-zds": true, children: [testimonial.hasAuthorAvatar && jsx("div", { className: styles.avatarContainer, "data-zds": true, children: jsx(Avatar, { "data-testId": "Avatar", name: testimonial.author, url: testimonial.avatarUrl, size: "medium" }) }), jsx("div", { className: styles.quote, "data-zds": true, children: testimonial.quote }), jsxs("p", { className: styles.author, "data-zds": true, children: [testimonial.author, ", ", testimonial.company] })] })] }, i)) }) }), paginator] });
};

export { TestimonialCarousel };
//# sourceMappingURL=TestimonialCarousel.es.js.map
